import { useMemo, useEffect, useState } from 'react';
import { useQuery } from '@apollo/react-hooks';

import { COURSE_LIST_QUERY } from 'app/gql';

export function useCourseListQuery() {
    // TODO: Remove fake loading timer.
    const [ isFakeLoading, setFakeLoading ] = useState( true );
    useEffect( () => {
        setTimeout( () => { setFakeLoading( false ); }, 2000 );
    }, [ setFakeLoading ] );

    const { data, loading, error } = useQuery( COURSE_LIST_QUERY, {} );
    return useMemo (
        () => ( {
            error,
            loading: ( loading || isFakeLoading ),
            data,
        } ), [ error, loading, data, isFakeLoading ]
    );
}
